// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import { MatLegacyListModule } from '@angular/material/legacy-list';

// Teller Online Library Files
import { PipesModule } from '../../pipes/pipes.module';

// Component Files
import { TellerOnlineScheduleDetailsComponent } from './schedule-details.component';

@NgModule({
    declarations: [TellerOnlineScheduleDetailsComponent],
    imports: [
        CommonModule,
        MatLegacyTableModule,
        MatLegacyListModule,
        PipesModule
    ],
    exports: [TellerOnlineScheduleDetailsComponent]
})
export class TellerOnlineScheduleDetailsModule {}
